
const Schedule = () => {
    return (
        <div className="mt-24">
            <h2 className="w-4/5 mx-auto pt-14 text-4xl font-bold md:text-xl md:pt-6">Event Schedule - 17<sup>th</sup> December</h2>
            <div className="w-full mt-10 mb-16 md:mt-6">
                <table className="w-4/5 mx-auto border-t border-gray-600 text-center">
                    <tr className="border-t border-gray-600">
                        <th className="font-bold p-2 border-t border-gray-600"></th>
                        <th colSpan={2} className="w-16 p-2 font-bold border-t border-gray-600">9:00</th>
                        <th colSpan={2} className="w-16 p-2 font-bold border-t border-gray-600">10:00</th>
                        <th colSpan={2} className="w-16 p-2 font-bold border-t border-gray-600">11:00</th>
                        <th colSpan={2} className="w-16 p-2 font-bold border-t border-gray-600">12:00</th>
                        <th colSpan={2} className="w-16 p-2 font-bold border-t border-gray-600">1:00</th>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 w-32 border-t border-r border-gray-600 md:p-0 md:h-14">Build-a-Drone</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={9} className="border-y border-gray-400 bg-[#502c7a]"> 9:30 AM - 3:30 PM</td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Fusion 360</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={9} className="border-y border-gray-400 bg-[#3e3386]"> 9:30 AM ONWARDS</td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Intro - ROS</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={9} className="border-y border-gray-400 bg-[#136ba6]"> 9:30 AM ONWARDS</td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Astronomia</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={8} className="border-y border-gray-400 bg-[#502c7a]"> 10:00 AM ONWARDS</td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Circuitra</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={5} className="border-y border-gray-400 bg-[#3e3386]"> 10:00 AM - 12:30 PM</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Product Expo</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={9} className="border-y border-gray-400 bg-[#136ba6]"> 9:30 AM ONWARDS</td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Mechtrix</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={7} className="border-y border-gray-400 bg-[#502c7a]">9:30 AM - 1:30 PM</td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Tech Talk</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={4} className="border-y border-gray-400 bg-[#3e3386]">10:30 AM - 12:30 PM</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Scenius</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={9} className="border-y border-gray-400 bg-[#136ba6]">9:00 AM - 3:30 PM</td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Shark Tank</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={8} className="border-y border-gray-400 bg-[#502c7a]">9:30 AM - 1:30 PM</td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Line Follower</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={7} className="border-y border-gray-400 bg-[#3e3386]">9:30 AM - 1:30 PM</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Amplify</td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={6} className="border-y border-gray-400 bg-[#136ba6]">9:30 AM - 12:30 PM</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">E Sports</td>
                        <td colSpan={10} className="border-y border-gray-400 bg-[#502c7a]">9:00 AM - 3:30 PM</td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Kalasrishti</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={6} className="border-y border-gray-400 bg-[#3e3386]">10:00 AM - 1:00 PM</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-t border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Roulette</td>
                        <td colSpan={7} className="border-y border-gray-400 bg-[#136ba6]">9:00 AM - 12:30 PM</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                    </tr>
                    <tr className="border-y border-gray-600">
                        <td className="font-bold p-2 border-t border-r border-gray-600 md:p-0 md:h-14">Dance it Out</td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td className="w-16 border-gray-600"></td>
                        <td colSpan={2} className="border-y border-gray-400 bg-[#502c7a]">1 - 3 PM</td>
                    </tr>
                </table>
            </div>
        </div>
    )
}

export default Schedule